import {
  Dispatch,
  JSXElementConstructor,
  ReactElement,
  SetStateAction,
} from 'react';

import styled, { useTheme } from 'styled-components';

import CustomIcon from '@components/utils/CustomIcon';
import { CloseIcon } from '@assets/icons';
import Tooltip from '@components/ui/Tooltip/next';
import { useDevice } from '@contexts/device';
import Markdown from '@components/utils/Markdown';

const TooltipHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

const TooltipTitle = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.white};
`;

const TooltipText = styled.span`
  font-weight: 400;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.white};
`;

interface Props {
  children: ReactElement<any, string | JSXElementConstructor<any>> | undefined;
  open: boolean;
  toggleTooltip: Dispatch<SetStateAction<boolean>>;
  message: string;
  homePageResponsive?: boolean;
}

const ChatGPTTooltip = ({
  children,
  open,
  toggleTooltip,
  message,
  homePageResponsive,
}: Props) => {
  const { palette } = useTheme();

  const handleCloseTooltip = () => {
    toggleTooltip(false);
    sessionStorage.setItem('isTooltipViewed', 'true');
  };
  const { isDesktop } = useDevice();
  return (
    <div>
      {homePageResponsive && !isDesktop ? (
        <Tooltip getPopupContainer={(node) => node} open={open}>
          {children}
        </Tooltip>
      ) : (
        <Tooltip
          getPopupContainer={(node) => node}
          open={open}
          overlayInnerStyle={{
            width: '175px',
            backgroundColor: palette.persianRed,
          }}
          overlayStyle={{
            backgroundColor: palette.persianRed,
            borderRadius: '8px',
          }}
          arrowColor={palette.persianRed}
          title={() => (
            <>
              <TooltipHeader>
                <TooltipTitle>Seyahat Asistanı</TooltipTitle>
                <CustomIcon
                  icon={CloseIcon}
                  fontSize={16}
                  paletteColor='white'
                  clickable
                  onClick={handleCloseTooltip}
                />
              </TooltipHeader>

              {message && open ? (
                <TooltipText>
                  <Markdown text={message} />
                </TooltipText>
              ) : null}
            </>
          )}
          placement='left'
        >
          {children}
        </Tooltip>
      )}
    </div>
  );
};

export default ChatGPTTooltip;
